/*
  Selection helpers for scheduler cells.
*/

export function getCellKey(cell) {
  return cell?.row?.id && cell?.day?.key ? `${cell.row.id}::${cell.day.key}` : "";
}

export function getCellSelectionScopeKey(cell) {
  return cell?.rowMode && cell?.row?.id ? `${cell.rowMode}::${cell.row.id}` : "";
}

export function normalizeCellSelection(cells, anchorCell = null) {
  const anchorScopeKey = getCellSelectionScopeKey(anchorCell);
  const cellsByKey = new Map();
  let scopeKey = anchorScopeKey;

  (Array.isArray(cells) ? cells : []).forEach((cell) => {
    const cellKey = getCellKey(cell);
    const cellScopeKey = getCellSelectionScopeKey(cell);
    if (!cellKey || !cellScopeKey) return;

    if (!scopeKey) scopeKey = cellScopeKey;
    if (cellScopeKey !== scopeKey) return;

    cellsByKey.set(cellKey, cell);
  });

  return Array.from(cellsByKey.values());
}

export function mergeCellSelections(currentCells, nextCells) {
  const nextSelection = normalizeCellSelection(nextCells);
  if (!nextSelection.length) return normalizeCellSelection(currentCells);

  const currentSelection = normalizeCellSelection(currentCells);
  const currentScopeKey = getCellSelectionScopeKey(currentSelection[0]);
  const nextScopeKey = getCellSelectionScopeKey(nextSelection[0]);
  if (currentScopeKey && nextScopeKey && currentScopeKey !== nextScopeKey) return nextSelection;

  return normalizeCellSelection([...currentSelection, ...nextSelection], nextSelection[0]);
}

export function toggleCellContext(currentCells, cell) {
  const cellKey = getCellKey(cell);
  const cellScopeKey = getCellSelectionScopeKey(cell);
  if (!cellKey || !cellScopeKey) return normalizeCellSelection(currentCells);

  const currentSelection = normalizeCellSelection(currentCells);
  const currentScopeKey = getCellSelectionScopeKey(currentSelection[0]);
  if (currentScopeKey && currentScopeKey !== cellScopeKey) return [cell];

  if (currentSelection.some((candidate) => getCellKey(candidate) === cellKey)) {
    return currentSelection.filter((candidate) => getCellKey(candidate) !== cellKey);
  }

  return [...currentSelection, cell];
}
